import { Box, Skeleton } from "@mui/material";

const RelatedListSkeleton = () => {
    return (
        <Box sx={{ marginTop: 2 }} gap={1} display="flex" flexDirection="column">
            <Box display="flex" flexDirection="row" gap={1}>
                <Skeleton variant="rectangular" height={40} width={80} />
                <Skeleton variant="rectangular" height={40} width={80} />
            </Box>
            <Skeleton variant="rounded" height={60} />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
        </Box>
    );
};

export default RelatedListSkeleton;
